import { useClientPermissions } from '@/hooks/useClientPermissions';
import { ClientDashboard } from './ClientDashboard';

interface ClientRouteProtectionProps {
  children: React.ReactNode;
}

export const ClientRouteProtection = ({ children }: ClientRouteProtectionProps) => {
  const { isClient } = useClientPermissions();
  
  // If user is a client, show the client dashboard instead of the requested page
  if (isClient) {
    return <ClientDashboard />;
  }
  
  // Non-clients get the normal content
  return <>{children}</>;
};